module.exports = __webpack_public_path__ + "static/img/jj_bg.edbe32a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solve/jj_bg.png
// module id = mq2t
// module chunks = 1